module.exports = __webpack_public_path__ + "static/Anbaugebiet-Hessische-Bergstrasse-600x648-68edf79e6fdf3fd45c04f4aafad14ff4.jpeg";